import { Popover as MuiPopover, type PopoverOrigin, type PopoverProps as MuiPopoverProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

const DIALOG_ROLE = 'dialog';
const PAPER_PADDING = 2;
const DEFAULT_ANCHOR_ORIGIN: PopoverOrigin = { vertical: 'bottom', horizontal: 'left' };

type Props = WithoutStyleOverrides<Omit<MuiPopoverProps, 'slots' | 'slotProps' | 'elevation' | 'aria-label' | 'aria-labelledby'>> & {
  'aria-label'?: string;
  'aria-labelledby'?: string;
};

export function Popover(props: Props) {
  const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, anchorOrigin = DEFAULT_ANCHOR_ORIGIN, ...popoverProps } = props;

  return (
    <MuiPopover
      {...popoverProps}
      anchorOrigin={anchorOrigin}
      slotProps={{
        paper: {
          role: DIALOG_ROLE,
          'aria-label': ariaLabel,
          'aria-labelledby': ariaLabelledBy,
          sx: { padding: PAPER_PADDING },
        },
      }}
    />
  );
}

export type { Props as PopoverProps };
